import { useSelector } from 'react-redux'
import { getRulesSelector } from '../../rules/selectors'

const useAreAllWarningsCleared = () => {
  const rulesState = useSelector(getRulesSelector)
  const { errors, isLoading } = rulesState
  const errorsLength = Object.values(errors)
    .flat()
    .filter((err) => err.errorType === 'warning').length
  return !isLoading && errorsLength === 0
}
export default useAreAllWarningsCleared
